export const menuText = [
    {
      id: 0,
      text: "UNIQUE P2E",
      link: '/unique-p2e',
    },
    {
      id: 1,
      text: "KNIGHTS NFT",
      link: '/knights-nft',
    },
    {
      id: 2,
      text: "PASSIVE INCOME",
      link: '/passive-income',
    },
    {
      id: 3,
      text: "GET ALLOWLISTED",
      link: '/get-allowlisted',
    },
    {
      id: 4,
      text: "MINT PAGE",
      link: '/mint-page',
    },
    {
      id: 5,
      text: "STAKING POOL",
      link: '/staking-pool',
    },
  ]